enum HandShakeCommunicationKey {
  Done = 'handShakeDone',
  Exception = 'handShakeException',
  ShouldRequest = 'requestHandShake',
}

enum SessionCommunicationKey {
  Created = 'SessionCreated',
  CreationFailed = 'SessionCreationFailed',
  ValiditySuccess = 'SessionValidityCheckSuccess',
  ValidityFailed = 'SessionValidityCheckFailed',
  SessionEndingSuccess = 'SessionEndingSuccess',
  SessionEndingFailure = 'SessionEndingFailure',
}

enum ComponentCommunicationKey {
  Sent = 'componentSent',
}

enum AnswerCommunicationKey {
  Success = 'answerWorkflowSucceed',
  Failed = 'answerWorkflowFailed',
}

enum WearableCommunicationKey {
  GetWithingsKeysSuccess = 'GetWithingTokenDone',
  GetWithingsKeysFailed = 'GetWearablesTokensFailed',
  WithingsAuthSaveDone = 'WithingsAuthSaveDone',
  WithingsIdDuplicateInDB = 'WithingsIdDuplicateInDB',
  WithingsAuthSaveFailed = 'WithingsAuthSaveFailed',
  WithingsRollbackSuccess = 'WithingsRollbackSuccess',
  WithingsRollbackFailed = 'WithingsRollbackFailed',
  GetWerableDataSuccess = 'WearablesDataSuccess',
  GetWerableDataFailure = 'WearablesDataFailure',
}

enum DummyPatientCommunicationKey {
  CreationSuccess = 'DummyPatientProcessStarted',
  UpdateSuccess = 'dummyPatientCreationSucceed',
  UpdateFailed = 'dummyPatientCreationFailed',
  ProcessFailure = 'DummyPatientProcessFailure',
  Cooldown = '5mnScanCooldown',
  NonMedicalCountry = 'NonMedicalCountry',
  Under18 = 'hasThresholdUnder18WithHandshake',
  Under18WithoutHandshake = 'hasThresholdUnder18WithoutHandshake',
  CarepathwayAlreadyAssigned = 'AlreadyAssignedCarepathway',
  PatientIssue = 'PatientIssue',
}

enum AccountCommunicationKey {
  Create = 'createAccount',
  CreationSuccess = 'AccountCreationSuccess',
  CreationFailed = 'AccountCreationFailed',
  PinVerified = 'PinVerified',
  PinUnverified = 'PinNotVerified',
  PinExpired = 'PinExpired',
  RegistrationStatusSuccess = 'patientRegistrationInformationCheckSucceed',
  RegistrationStatusFailed = 'patientRegistrationInformationCheckFailed',
}

enum UserCommunicationKey {
  Valid = 'UserNotExist',
  Invalid = 'UserExist',
}

enum InsuranceTypesCommunicationKey {
  Success = 'GetInsuranceTypesSuccess',
  Failed = 'GetInsuranceTypesError',
}

enum MedicationPlanCommunicationKey {
  Success = 'BMP_SUCCESS_ASSIGNING',
  Failure = 'BMP_FAILURE_UNEXPECTED',
  Duplicated = 'BMP_FAILURE_DUPLICATE_BMP',
  AssetSuccess = 'BMP_SUCCESS_GENERATING_ASSET',
  NotSupported = 'BMP_FAILURE_NOT_SUPPORTED_BMP',
  ArchiveSuccess = 'BMP_SUCCESS_ARCHIVING',
  ArchivingFailed = 'BMP_FAILURE_ARCHIVING',
  FetchMedicationPlanAssetSuccess = 'ActiveMedicationPlanResult',
  FetchMedicationPlanAssetFailed = 'FetchingActiveMedicationPlanFailure',
  MedicationPlanAssetNotFound = 'ActiveMedicationPlanNotFound',
}

enum PatientSettingsCommunicationKey {
  FetchSettingsSuccess = 'fetchSettingsSuccess',
  FetchSettingsFailure = 'fetchSettingsFailure',
  UpdateSettingsSuccess = 'updateSettingsSuccess',
  UpdateSettingsFailure = 'updateSettingsFailure',
}

enum TasksSummaryCommunicationKey {
  Success = 'SUCCESS_PATIENT_TASKS_SUMMARY',
  Failure = 'FAILURE_PATIENT_TASKS_SUMMARY',
}

enum TaskDetailsCommunicationKey {
  Success = 'SUCCESS_CAREPLAN_FULL_DETAILS',
  Failure = 'FAILURE_CAREPLAN_FULL_DETAILS',
}

enum TaskSubmittedDataCommunicationKey {
  Success = 'caretaskGraphDataSuccess',
  Failure = 'caretaskGraphDataFailure',
}

enum SocalMediaCommunicationKey {
  Success = 'GetSocialMediaLinksSuccess',
  Failure = 'GetSocialMediaLinksError',
}

export const CommunicationKeys = {
  HandShake: HandShakeCommunicationKey,
  Session: SessionCommunicationKey,
  Component: ComponentCommunicationKey,
  Answer: AnswerCommunicationKey,
  DummyPatient: DummyPatientCommunicationKey,
  Account: AccountCommunicationKey,
  User: UserCommunicationKey,
  InsuranceTypes: InsuranceTypesCommunicationKey,
  Wearables: WearableCommunicationKey,
  MedicationPlan: MedicationPlanCommunicationKey,
  TasksSummary: TasksSummaryCommunicationKey,
  TaskDetails: TaskDetailsCommunicationKey,
  PatientSettings: PatientSettingsCommunicationKey,
  TaskSubmittedData: TaskSubmittedDataCommunicationKey,
  SocalMedia: SocalMediaCommunicationKey,
};

export type CommunicationKey =
  | HandShakeCommunicationKey
  | SessionCommunicationKey
  | ComponentCommunicationKey
  | AnswerCommunicationKey
  | DummyPatientCommunicationKey
  | AccountCommunicationKey
  | UserCommunicationKey
  | InsuranceTypesCommunicationKey
  | WearableCommunicationKey
  | MedicationPlanCommunicationKey
  | TasksSummaryCommunicationKey
  | TaskDetailsCommunicationKey
  | PatientSettingsCommunicationKey
  | TaskSubmittedDataCommunicationKey
  | SocalMediaCommunicationKey;
